import { allRoles } from "../data/master_lists";
import { UserRolesEnum } from "../constants/user-roles.enum";

/**
 * Returns the display name of a role given its value.
 * @param roleValue The role value (enum value)
 * @returns The name of the role or the value if not found
 */
export function getRoleName(roleValue: string): string {
    return allRoles.find(r => r.value === roleValue)?.name || roleValue;
}

/**
 * Returns true if the given role is a Sales Representative role.
 * Centralizes the check to avoid duplication across modals.
 * Covers both SALES_PERSON_ROLE ('SALESPER_ROLE') and SALES_ROLE ('SALES_ROLE').
 */
export function isSalesRepRole(role?: string | null): boolean {
    if (!role) return false;
    return role === UserRolesEnum.SALES_PERSON_ROLE || role === UserRolesEnum.SALES_ROLE;
}
